(function iife(w, d) {
    function setAriaLabel(el, val) {
        el.setAttribute('aria-expanded', val);
    }

    function toggleMenu() {
        const menuButton = document.querySelector('#MenuButton');
        const submenuButton = document.querySelectorAll('.SubNav__button');

        menuButton.addEventListener('click', () => {
            if (menuButton.getAttribute('aria-expanded') === 'false') {
                setAriaLabel(menuButton, 'true');
            } else {
                setAriaLabel(menuButton, 'false');
            }
        });

        submenuButton.forEach((button) => {
            button.addEventListener('click', () => {
                if (button.getAttribute('aria-expanded') === 'false') {
                    setAriaLabel(button, 'true');
                } else {
                    setAriaLabel(button, 'false');
                }
            });
        });
    }

    toggleMenu();
}(typeof global !== 'undefined' ? global : window, document));
